import {
  deleteApiAlbumsId,
  getApiAlbumsId,
  patchApiAlbumsIdName,
  postApiAlbums,
  putApiAlbumsId,
  putApiAlbumsIdTracksOrder,
} from '@/shared/api'
import { createMutation, createQuery } from '@farfetched/core'

export const albumByIdQuery = createQuery({
  handler: getApiAlbumsId,
})

export const albumTrackPositionUpdate = createQuery({
  handler: putApiAlbumsIdTracksOrder,
})

export const albumCreate = createMutation({
  handler: postApiAlbums,
})

export const albumNameUpdate = createMutation({
  handler: patchApiAlbumsIdName,
})

export const albumUpdate = createMutation({
  handler: putApiAlbumsId,
})

export const albumDelete = createMutation({
  handler: deleteApiAlbumsId,
})
